<template>
    <div class="wrapper" style="width: 100%;margin-top:20px;">
        <div style="width: 25%;">
            <div style="display: flex;justify-content: end">
                <SidebarMenu sidebarTitle="系统设置" :menu-list="menuList" :active-menu="activeMenu" @menu-click="handleMenuClick"/>
            </div>
        </div>
        <div style="width: 2%;"></div>
        <div style="width: 78%;padding: 0 2rem 0 0;">
            <div class="content-header">
                <h1 class="content-title">{{ currentMenuTitle }}</h1>
<!--                <p class="content-subtitle">{{ currentMenuDesc }}</p>-->
            </div>
            <div class="weather-content">
                <ListIndex  v-if="active === 'list'" />
                <MeteringIndex  v-if="active === 'metering'" />
                <FreeIndex v-if="active === 'free'"/>

                <BuyIndex v-if="active === 'buy'" @show-add="showBuyAdd"  @show-detail="showBuyDetail" @show-edit="showBuyEdit"/>
                <BuyIndexAdd v-if="active === 'buy-add'" @show-index="showBuyIndex" />
                <BuyIndexDetail v-if="active === 'buy-detail'"  @show-index="showBuyIndex" :id="id"/>
                <BuyIndexEdit v-if="active === 'buy-edit'" @show-index="showBuyIndex" :id="id"/>

                <UseIndex v-if="active === 'use'" @show-use-add="showUseAdd"  @show-use-detail="showUseDetail" @show-use-edit="showUseEdit"/>
                <UseAddIndex v-if="active === 'use-add'" @show-use-index="showUseIndex" />
                <UseEditIndex v-if="active === 'use-edit'"  @show-use-index="showUseIndex" :id="id"/>
                <UseDetailIndex v-if="active === 'use-detail'" @show-use-index="showUseIndex" :id="id"/>

                <TransferIndex v-if="active === 'transfer'" @show-transfer-add="showTransferAdd"  @show-transfer-detail="showTransferDetail" @show-transfer-edit="showTransferEdit"/>
                <TransferAddIndex v-if="active === 'transfer-add'" @show-transfer-index="showTransferIndex" />
                <TransferEditIndex v-if="active === 'transfer-edit'"  @show-transfer-index="showTransferIndex" :id="id"/>
                <TransferDetailIndex v-if="active === 'transfer-detail'" @show-transfer-index="showTransferIndex" :id="id"/>

                <CheckIndex v-if="active === 'check'" @show-check-add="showCheckAdd"  @show-check-detail="showCheckDetail" @show-check-edit="showCheckEdit"/>
                <CheckAddIndex v-if="active === 'check-add'" @show-check-index="showCheckIndex" />
                <CheckEditIndex v-if="active === 'check-edit'"  @show-check-index="showCheckIndex" :id="id"/>
                <CheckDetailIndex v-if="active === 'check-detail'" @show-check-index="showCheckIndex" :id="id"/>

                <ScrapIndex v-if="active === 'scrap'" @show-scrap-add="showScrapAdd"  @show-scrap-detail="showScrapDetail" @show-scrap-edit="showScrapEdit"/>
                <ScrapAddIndex v-if="active === 'scrap-add'" @show-scrap-index="showScrapIndex" />
                <ScrapEditIndex v-if="active === 'scrap-edit'"  @show-scrap-index="showScrapIndex" :id="id"/>
                <ScrapDetailIndex v-if="active === 'scrap-detail'" @show-scrap-index="showScrapIndex" :id="id"/>

                <AnalysisIndex v-if="active === 'analysis'"/>

            </div>
        </div>
    </div>
</template>

<script>
import SidebarMenu from "@/components/water-affairs-style/sidebarMenu.vue";
import ListIndex from "./list/index.vue";
import MeteringIndex from "./metering/index.vue";
import FreeIndex from "./free/index.vue";

import BuyIndex from "./buy/index.vue";
import BuyIndexAdd from "./buy/add.vue";
import BuyIndexDetail from "./buy/detail.vue";
import BuyIndexEdit from "./buy/edit.vue";

import UseIndex from "./use/index.vue";
import UseAddIndex from './use/add.vue'
import UseDetailIndex from './use/detail.vue'
import UseEditIndex from './use/edit.vue'

import TransferIndex from "./transfer/index.vue";
import TransferAddIndex from './transfer/add.vue'
import TransferEditIndex from './transfer/edit.vue'
import TransferDetailIndex from './transfer/detail.vue'

import CheckIndex from "./check/index.vue";
import CheckAddIndex from './check/add.vue'
import CheckEditIndex from './check/edit.vue'
import CheckDetailIndex from './check/detail.vue'

import ScrapIndex from "./scrap/index.vue";
import ScrapAddIndex from './scrap/add.vue'
import ScrapEditIndex from './scrap/edit.vue'
import ScrapDetailIndex from './scrap/detail.vue'

import AnalysisIndex from "./analysis/index.vue";



export default {
    components: {
        SidebarMenu,ListIndex,MeteringIndex,FreeIndex,BuyIndex,UseIndex,TransferIndex,CheckIndex,ScrapIndex,AnalysisIndex,
        BuyIndexAdd,BuyIndexDetail,BuyIndexEdit,UseAddIndex,UseEditIndex,UseDetailIndex,
        TransferAddIndex,TransferEditIndex,TransferDetailIndex,
        CheckAddIndex,CheckEditIndex,CheckDetailIndex,
        ScrapAddIndex,ScrapEditIndex,ScrapDetailIndex,
    },
    computed: {
        currentMenuTitle() {
            const menu = this.menuList.find(m => m.key === this.activeMenu);
            return menu ? menu.title : '基础设置';
        },
        currentMenuDesc() {
            const menu = this.menuList.find(m => m.key === this.activeMenu);
            return menu ? menu.desc : '配置系统基本参数和运行环境';
        },
        currentLink() {
            const menu = this.menuList.find(m => m.key === this.activeMenu);
            return menu ? menu.link : '/property/list';
        }
    },
    data() {
        return {
            active: "list",
            activeMenu: 'list',
            menuList: [
                { key: 'list', title: '实物资产台账', icon: '⚙️', desc: '实物资产台账',link:'/property/list' },
                { key: 'metering', title: '计量资产台账', icon: '⚙️', desc: '计量资产台账',link:'/property/metering' },
                { key: 'free', title: '闲置资产台账', icon: '⚙️', desc: '闲置资产台账',link:'/property/free' },
                { key: 'buy', title: '资产采购', icon: '📋', desc: '资产采购',link:'/property/buy' },
                { key: 'use', title: '资产领用', icon: '👤', desc: '资产领用',link:'/property/use' },
                { key: 'transfer', title: '资产转移', icon: '🔔', desc: '资产转移' ,link:'/property/transfer'},
                { key: 'check', title: '资产盘点', icon: '🔐', desc: '资产盘点',link:'/property/check' },
                { key: 'scrap', title: '资产报废', icon: '🔗', desc: '资产报废',link:'/property/scrap' },
                { key: 'analysis', title: '月增资产总价值统计', icon: '💾', desc: '月增资产总价值统计' ,link:'/property/analysis'},
            ],
            id:null
        };
    },
    methods: {
        handleMenuClick(menuKey) {
            this.activeMenu = menuKey;
            this.active = menuKey;
        },
        showBuyIndex(){
            this.active = 'buy';
        },
        showBuyAdd() {
            this.active = 'buy-add';
        },
        showBuyDetail(id){
            this.active = 'buy-detail';this.id = id;
        },
        showBuyEdit(id){
            this.active = 'buy-edit';this.id = id;
        },
        showUseIndex(){
            this.active = 'use';
        },
        showUseAdd() {
            this.active = 'use-add';
        },
        showUseDetail(id){
            this.active = 'use-detail';this.id = id;
        },
        showUseEdit(id){
            this.active = 'use-edit';this.id = id;
        },
        showTransferIndex(){
            this.active = 'transfer';
        },
        showTransferAdd() {
            this.active = 'transfer-add';
        },
        showTransferDetail(id){
            this.active = 'transfer-detail';this.id = id;
        },
        showTransferEdit(id){
            this.active = 'transfer-edit';this.id = id;
        },
        showCheckIndex(){
            this.active = 'check';
        },
        showCheckAdd() {
            this.active = 'check-add';
        },
        showCheckDetail(id){
            this.active = 'check-detail';this.id = id;
        },
        showCheckEdit(id){
            this.active = 'check-edit';this.id = id;
        },
        showScrapIndex(){
            this.active = 'scrap';
        },
        showScrapAdd() {
            this.active = 'scrap-add';
        },
        showScrapDetail(id){
            this.active = 'scrap-detail';this.id = id;
        },
        showScrapEdit(id){
            this.active = 'scrap-edit';this.id = id;
        },
    }
};
</script>


<style lang="less" scoped>
.wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 100%;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;

  .content-title {
    font-size: 1.8rem;
    font-weight: bold;
    background: linear-gradient(135deg, #fff, #00ff96);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 0.5rem;
  }

  .content-subtitle {
    color: #64748b;
    font-size: 0.95rem;
  }

  .weather-content {
    background: rgba(20, 35, 70, 0.5);
    //backdrop-filter: blur(10px);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 2rem;
    margin-bottom: 1.5rem;
  }
}
</style>